import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Header from '../../components/dashboard/Header';
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Overview from '../../components/dashboard/overview/Overview';
import LinearProgress from '@mui/material/LinearProgress';

const DashboardPage = () => {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeMenuItem, setActiveMenuItem] = useState('آمار کلی');

  useEffect(() => {
    const path = window.location.pathname;
    const idMatch = path.match(/\/project\/(\d+)\/dashboard/);

    if (idMatch && idMatch[1]) {
      fetch(`/db/get-project.php?id=${idMatch[1]}`)
        .then(res => res.json())
        .then(result => {
          if (result.status === 'success') {
            setProject(result.project);
          }
        })
        .catch(err => {
          console.error("خطا در گرفتن اطلاعات پروژه:", err);
        })
        .finally(() => {
          setTimeout(() => setLoading(false), 2000);
        });
    } else {
      setLoading(false);
      setProject(null);
    }

    const menuItemMatch = path.match(/\/dashboard\/([^\/]+)$/);
    if (menuItemMatch && menuItemMatch[1]) {
      switch (menuItemMatch[1].toLowerCase()) {
        case 'overview':
          setActiveMenuItem('آمار کلی');
          break;
        case 'products':
          setActiveMenuItem('محصولات');
          break;
        case 'orders':
          setActiveMenuItem('سفارشات');
          break;
        case 'customers':
          setActiveMenuItem('مشتریان');
          break;
        case 'settings':
          setActiveMenuItem('تنظیمات');
          break;
        default:
          setActiveMenuItem('آمار کلی');
          break;
      }
    } else {
      setActiveMenuItem('آمار کلی');
    }
  }, []);

  const handleMenuItemClick = (item) => {
    setActiveMenuItem(item);
  };


  return (
    <>
      <Header />
      {loading && <LinearProgress />}

      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        {/* منوی کناری - سمت راست */}
        <DashboardMenu activeItem={activeMenuItem} onItemClick={handleMenuItemClick} />

        {/* قسمت اصلی - سمت چپ */}
        <Box component="main" sx={{ flexGrow: 1 , p: 2}}>
          {loading ? (
            <>
              {/* <Typography variant="h5" gutterBottom align="center">
                در حال بارگذاری...
              </Typography>
              <Grid container spacing={2}>
                {[1, 2, 3, 4].map(i => (
                  <Grid item xs={12} sm={6} md={4} key={i}>
                    <Paper sx={{ p: 2, backgroundColor: '#303B4B' }}>
                      <Skeleton variant="text" width="80%" height={30} />
                      <Skeleton variant="rectangular" height={60} sx={{ mt: 1 }} />
                    </Paper>
                  </Grid>
                ))}
              </Grid> */}
            </>
          ) : project ? (
            <>
              {activeMenuItem === 'آمار کلی' && <Overview projectId={project.id} />}
              {activeMenuItem === 'محصولات' && <Typography>محصولات</Typography>}
              {activeMenuItem === 'سفارشات' && <Typography>سفارشات</Typography>}
              {activeMenuItem === 'مشتریان' && <Typography>مشتریان</Typography>}
              {activeMenuItem === 'تنظیمات' && <Typography>تنظیمات</Typography>}
            </>
          ) : (
            <Typography align="center" color="#888" sx={{ mt: 3 }}>
              پروژه ای یافت نشد.
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default DashboardPage;